<template>
  <div class="education">
    <ListTitle :title="title" :titleImg="titleImg" />
    <ListGroup :itemList="itemList" :fn="goToDetails" />
    <Footer />
  </div>
</template>
<script>
import Footer from "@/components/layouts/footer.vue";
import ListTitle from "@/components/ui/searchList/ListTitle.vue";
import ListGroup from "@/components/ui/searchList/ListGroup.vue";
export default {
  props: {
    title: {
      type: String,
      default: "愛樹教育"
    },
    titleImg: {
      type: String,
      default: "common/icon_edu.svg"
    }
  },
  data() {
    return {
      itemList: []
    };
  },
  components: {
    Footer,
    ListTitle,
    ListGroup
  },
  mounted() {
    this.itemList = [];
    // this.$store.dispatch("setProcessWait", [
    this.$store.dispatch("setLoading", true);
    this.$store.dispatch("getEducationList").then(() => {
      this.$store.dispatch("setLoading", false);
    });
    // ]);
    this.itemList = this.$store.state.education.list;
  },
  methods: {
    goToDetails(item, idx) {
      this.SYS.goToDetails(
        item,
        idx,
        this.itemList,
        "Education-Detail"
        //this.$router
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.education {
  background-color: #f6edd9;
}
</style>
